import { FormField, FormInput } from "./FormField.jsx";

export function AccountModalStepCompany({ form, set, errors }) {
  return (
    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 20, marginBottom: 24 }}>
      <FormField label="Company name" required error={errors.companyName}>
        <FormInput value={form.companyName} onChange={(v) => set("companyName", v)} placeholder="e.g. Acme Logistics" error={errors.companyName} />
      </FormField>
      <FormField label="Industry" half>
        <FormInput value={form.industry} onChange={(v) => set("industry", v)} placeholder="e.g. Courier & Logistics" />
      </FormField>
      <FormField label="Website" half>
        <FormInput value={form.website} onChange={(v) => set("website", v)} placeholder="https://..." />
      </FormField>
      <FormField label="City" half>
        <FormInput value={form.city} onChange={(v) => set("city", v)} placeholder="e.g. Bengaluru" />
      </FormField>
      <FormField label="State" half>
        <FormInput value={form.state} onChange={(v) => set("state", v)} placeholder="e.g. Karnataka" />
      </FormField>
    </div>
  );
}
